import React, {useState} from "react";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {IconButton, InputAdornment, TextField, TextFieldProps} from "@mui/material";

const PasswordInput = (props: TextFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <TextField
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
              onMouseDown={e => e.preventDefault()}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
        autoComplete: "off"
      }}
      {...props}
    />
  );
};

export default PasswordInput;
